module.exports = __webpack_public_path__ + "img/visa.b32f4769.png";